// extracted by mini-css-extract-plugin
export var callCard = "_rx-0";
export var callMessageButton = "_rx-1";
export var helpIcon = "_rx-3";
export var helpIconContainer = "_rx-4";
export var verticalDivider = "_rx-2";